import MyDashboards from "MyDashboards/views/MyDashboards/MyDashboards";
import MyDashboardsToolbar from "components/toolbars/MyDashboardsToolbar";
import PageContainer from "design/layouts/PageContainer";
import Page from "design/pages/Page";
import React from "react";

const MyDashboardsPage = () => {
  return (
    <Page Toolbar={MyDashboardsToolbar}>
      <PageContainer width="100%">
        <MyDashboards />
      </PageContainer>
    </Page>
  );
};

export default MyDashboardsPage;
